import ChevronRight from '../../../../assets/icons/grey-chevron-right.svg';
// import ChevronRight from '../../../../'
import './QuickFileListRow.less';

interface QuickFileListRowProps {
  leadingIcon: string;
  title: string;
  subtitle?: string;
  count?: number;
  onClick?: () => void;
}

const QuickFileListRow = ({ leadingIcon, title, subtitle, count, onClick }: QuickFileListRowProps) => {
  return (
    <div className="qf-row" onClick={onClick} role="button" tabIndex={0}>
      <div className="qf-left">
        <img className="qf-row-icon" src={leadingIcon} alt="icon" />
      </div>
      <div className="qf-row-middle">
        <div className="qf-row-title">{title}</div>
        <div className="qf-row-subline">
          {subtitle && <span className="qf-row-subtitle">{subtitle}</span>}
        </div>
      </div>
      {typeof count === 'number' && <span className="qf-row-count">{count}</span>}
      <img className="qf-row-chevron" src={ChevronRight} alt="chevron" />
    </div>
  );
};

export default QuickFileListRow;
